import { routerRedux } from 'dva/router';
import { reloadAuthorized } from 'utils/Authorized';
import {
  getAccessToken,
  setAccessToken,
  setRefreshToken
} from 'utils/sessionToken';
import { getDataPlatformPermission, getTenantContext, checkUserNeedLogout } from 'src/services/cedar';
import { setPermissionCodeList, useUser, useTenantsContext, getUserPermission } from '../common/gobalState';
import { getAppUrl, getSSOLogoutUrl } from '../utils/sso';
import { getUserPersonId, getUserTenantId } from 'src/utils/tenantContext';
import { formatPermissionObj } from 'src/utils/utils';
import { convertContext } from 'src/gs-utils/core/utils';
import { message } from 'antd';


function* fetchTenantsContext(_, { call, put }) {
  try {
    const res = yield call(getTenantContext);
    if(res.code === 0){
      const contextData = convertContext(res.data);
      yield put({
        type: 'changeTenantsContext',
        payload: contextData,
      });
      const [, setTenants] = useTenantsContext();
      const [, setUser] = useUser();
      setTenants(contextData);
      setUser({
        email: contextData.person.contactEmail,
      });
      yield put({
        type: 'changeCurrentUser',
        payload: {
          email: contextData.person.contactEmail,
        },
      });
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: true,
        },
      });
      reloadAuthorized();
    } else {
      yield put({
        type: 'logout',
      });
      throw Error(i('获取租户信息失败'));
    }
  } catch (err) {
    console.error('fetch tenants context Error', err);
    // yield put(routerRedux.replace('/exception/500')); safari info接口报错，页面空白
  }
}

/**
 * 检查用户角色权限，判断是否需要强制登录
 * @param {*} _ 
 * @param {*} param1 
 * write by cursor
 */
function* checkUserRolePermission(_, { call, put }) {
  try {
    const params = {
      appType: 'web',
    };
    
    const res = yield call(checkUserNeedLogout, params);
    
    // 检查返回结果
    if (res.code === 0) {
      
      if (res?.data?.needLogout === true) {
        return false; // 返回false表示校验失败
      }
      
      return true; // 返回true表示校验通过
    } else {
      // 接口调用失败，记录错误但不阻断流程
      return true; // 默认允许通过，避免因接口问题阻断正常流程
    }
  } catch (err) {
    return true; // 默认允许通过，避免因异常阻断正常流程
  }
}

function* fetchDataPlatformPermission(_, { call }) {
  try {
    const personId = getUserPersonId();
    const tenantId = getUserTenantId();
    const [user] = useUser();
    const { email } = user;
    const { permissions } = yield call(getDataPlatformPermission, { personId, tenantId });
    let permissionList = [];
    if (Array.isArray(permissions)) {
      if(permissions.length === 0) {
        window.location.href = `${window.location.origin}#/exception/403`;
      }
      permissionList = formatPermissionObj(permissions, "");
    }
    if (!!permissionList?.length ) {
      const dataPlatformPermission = {};
      permissionList.forEach(v => {
        dataPlatformPermission[v] = true
      })
      // const permissionObj = Object.assign({}, cloudPermission, dataPlatformPermission);
      console.log('dataPlatformPermission', dataPlatformPermission)
      const permissionObj = Object.assign({}, dataPlatformPermission);
      setPermissionCodeList(permissionObj);
    }
  } catch(err) {
    console.log('err', err)
  }
}

export default {
  namespace: 'login',

  state: {
    status: false,
    session: '',
    accessToken: '',
    refreshToken: '',
    errMsg: '',
    isSecurityCodeRequired: false,
    securityCodeImg: '',
    currentUser: {
      nickName: '',
      granted: 'ADMIN',
      email: '',
      companyCode: '',
      phoneNumber: '',
      jiraAccount: '', // jira 用户名
      jiraPassword: '', // jira 密码
    },
    tenantsContext: null
  },

  effects: {
    *fetchAccountInfo(_, { call, put, select }) {
      // 第一步：检查用户角色权限，判断是否可以进入应用
      const roleCheckResult = yield checkUserRolePermission(_, { call, put });
      
      // 如果角色校验失败，不再执行后续逻辑
      if (!roleCheckResult) {
        // 显示错误提示信息
        message.error(i("account_changed_error"));
        
        // 延迟1.5秒后执行登出逻辑
        yield call(() => new Promise(resolve => setTimeout(resolve, 1500)));
        
        yield put({
          type: 'logout',
        });
        
        return;
      }

      // 第二步：获取用户租户上下文信息
      yield fetchTenantsContext(_, { call, put });
      
      // 第三步：获取数据平台权限
      yield fetchDataPlatformPermission(_, { call });
    },
    *logout(_, { }) {
      setAccessToken('');
      setRefreshToken('');
      window.location.href = getSSOLogoutUrl();
    },
  },

  reducers: {
    changeErrMsg(state, { payload }) {
      return {
        ...state,
        errMsg: payload || '',
      };
    },
    changeIsSecurityCodeRequired(state, { payload }) {
      return {
        ...state,
        isSecurityCodeRequired: payload || false,
      };
    },
    changeSecurityCodeImg(state, { payload }) {
      return {
        ...state,
        securityCodeImg: payload || '',
      };
    },
    changeCurrentUser(state, { payload }) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...payload,
        },
      };
    },
    changeLoginStatus(state, { payload }) {
      return {
        ...state,
        status: payload.status,
        errMsg: '',
      };
    },
    changeSession(state, { payload }) {
      return {
        ...state,
        session: payload.session,
        accessToken: payload.accessToken
      };
    },
    changeAccessToken(state, { payload }) {
      return {
        ...state,
        accessToken: payload.accessToken
      };
    },
    changeRefreshToken(state, { payload }) {
      return {
        ...state,
        refreshToken: payload.refreshToken
      };
    },
    changeTenantsContext(state, { payload }) {
      return {
        ...state,
        tenantsContext: payload
      };
    }
  },
};
